package com.milta.feature.subscription.domain.entity

/** [GracePeriod]: the store is retrying a failed renewal — still a paid, active subscription, shown "Actif". */
enum class SubscriptionStatus { Active, GracePeriod, Trial, Expired, Cancelled }
